import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalHeader } from '@eventbrite/consumer-header.global-header';
import { InlineAlert } from '@eventbrite/marmalade';
import { Footer } from './Footer.js';
export function PageShell({ header, footer, banner, mainClassName, children, }) {
    return (_jsxs(_Fragment, { children: [_jsx(GlobalHeader, { ...header }), banner ? (_jsx("div", { "data-testid": "app-shell-banner", children: _jsx(InlineAlert, { description: banner.description, variant: banner.variant ?? 'info', title: banner.title, cta: banner.cta }) })) : null, _jsx("main", { className: mainClassName, children: children }), footer ? _jsx(Footer, { ...footer }) : null] }));
}
export default PageShell;
